import { HttpClient } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';

/**
 * D-144: antes de mover dinero el servidor puede pedir el código de verificación otra vez
 * (REQUIERE_2FA_RECIENTE). Este servicio abre la ventana, lo confirma y avisa si se puede
 * repetir la operación. Si llegan varias a la vez, se pide una sola vez.
 */
@Injectable({ providedIn: 'root' })
export class ConfirmarCodigoService {
  private readonly http = inject(HttpClient);
  readonly abierto = signal(false);
  private pendiente: Promise<boolean> | null = null;
  private resolver: ((ok: boolean) => void) | null = null;

  pedir(): Promise<boolean> {
    if (this.pendiente) return this.pendiente;
    this.pendiente = new Promise<boolean>((r) => (this.resolver = r));
    this.abierto.set(true);
    return this.pendiente;
  }

  async confirmar(codigo: string): Promise<void> {
    await firstValueFrom(this.http.post(`${environment.apiUrl}/auth/2fa/confirmar`, { codigo }));
    this.terminar(true);
  }

  cancelar(): void {
    this.terminar(false);
  }

  private terminar(ok: boolean): void {
    this.abierto.set(false);
    this.resolver?.(ok);
    this.pendiente = null;
    this.resolver = null;
  }
}
